import React from 'react';

const getValueFromPath = (obj, path, defaultValue) => {
  const pathArr = path.split('.');
  let value = obj;
  for(let i = 0; i < pathArr.length; i++){
    value = value[pathArr[i]];
    if(!value) return defaultValue;
  }
  return value;
};

const Text = ({ path, children, data }) => {
  if ( !data ) {
    data = window.AFE_QUICK_CHECK_CONTENTS || {};
  }

  return getValueFromPath(data, path, children);
}

export default Text;
